<template>

    <div class="cumulative-group-warning">
        <Popup :class-name="showPopup ? 'open' : ''"
               @closePopup="closePopup">
            <h4 class="popup-title">Info message</h4>
            <div class="popup-content cumulative-warning-popup-content">
                <p>System identified a list of brands that are part of multiple {{ chartClassName }}. Please find below the list:</p><br>
                <div v-for="(warningData, index) in warningData" :key="warningData.brandNames">
                    <p><span style="font-weight: bold">{{ warningData.brandNames }}</span>: {{ warningData.cumulativeValues }}</p><br>
                </div>
            </div>
            <div class="buttons">
                <v-btn type="button" class="popup-btn" @click="closePopup">OK</v-btn>
            </div>
        </Popup>
    </div>

</template>

<script>
    import Popup from '../../common/Popup';

    export default {
        components: {
            Popup,
        },
        props: {
            chart: {
                type: Object,
            },
        },
        data() {
            return {
                showPopup: false,
                warningData: [],
                chartClassName: 'companies',
            }
        },
        mounted() {
            this.showCumulativeGroupWarning();
            this.convertClassToPlural();
        },
        methods: {
            showCumulativeGroupWarning() {
                const {cumulativeType} = this.chart.filters;
                let brandCumulativeData = [];
                if (cumulativeType === 'none') {
                    return;
                }

                let {data} = this.chart;

                if (this.chart.filters.chartType === 'growth') {
                    data = Object.keys(data)
                        .filter(dataKey => data[dataKey].length > 0)
                        .reduce((total, dataKey) => Object.assign(total, {[dataKey]: data[dataKey]}), {});
                }

                brandCumulativeData = Object.keys(data).map((dataKey) => {
                    const warningData = {};
                    warningData.cumulativeValues = data[dataKey][0].drug_brand_name.brand_name;
                    warningData.brandsName = data[dataKey][0].items[0].drug_brand_name.brand_name;
                    return warningData;
                });

                brandCumulativeData.forEach((valueData, indexData) => {
                    const warningDataObject = {};
                    const cumulativeValue = [];
                    let cumulativeBrandName = '';
                    brandCumulativeData.forEach((valueHelperData, indexHelperData) => {
                        if (valueData.brandsName === valueHelperData.brandsName) {
                            cumulativeValue.push(valueHelperData.cumulativeValues);
                            cumulativeBrandName = valueHelperData.brandsName;
                        }
                    });
                    warningDataObject.cumulativeValues = cumulativeValue.join(' / ');
                    warningDataObject.brandNames = cumulativeBrandName;
                    if (cumulativeValue.length > 1) {
                        this.warningData.push(warningDataObject);
                    }
                });
                const seen = new Set();
                this.warningData = this.warningData.filter((el) => {
                    const duplicate = seen.has(el.brandNames);
                    seen.add(el.brandNames);
                    return !duplicate;
                });

                if (this.warningData.length > 0) {
                    this.showPopup = true;
                }
            },
            convertClassToPlural() {
                switch (this.chart.filters.cumulativeType) {
                    case 'company': this.chartClassName = 'companies'; break;
                    case 'class': this.chartClassName = 'classes'; break;
                    case 'category': this.chartClassName = 'categories'; break;
                    case 'sub-category': this.chartClassName = 'sub-categories'; break;
                    default: this.chartClassName = 'companies';
                }
            },
            closePopup() {
                this.showPopup = !this.showPopup;
            },
        }
    }
</script>


<style lang="scss">
    @import '../../../style/Charts/ViewChart/CumulativeGroupWarningComponent';
</style>
